var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04538 11.6548C9.38416 11.6548 12.0908 9.0458 12.0908 5.82741C12.0908 2.60902 9.38416 0 6.04538 0C2.70661 0 0 2.60902 0 5.82741C0 9.0458 2.70661 11.6548 6.04538 11.6548ZM6.03798 9.99076C8.42282 9.99076 10.3561 8.12718 10.3561 5.82833C10.3561 3.52948 8.42282 1.66589 6.03798 1.66589C3.65314 1.66589 1.71985 3.52948 1.71985 5.82833C1.71985 8.12718 3.65314 9.99076 6.03798 9.99076Z",
    fill: "#949494"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.6136,
    height: 6.21853,
    rx: 0.806798,
    transform: "matrix(0.77105 -0.636775 0.664324 0.747445 8.62451 9.35199)",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.bf02d6c09093d4cb6552ded4c1debdca.svg";
export { ForwardRef as ReactComponent };